import { Action, ActionReducer, MetaReducer } from '@ngrx/store';

import { CognitoActions } from './actions/cognito.actions';
import { AssetsEffects } from "./effects/assets.effects";
import { CognitoEffects } from './effects/cognito.effects';
import { DownloadEffects } from './effects/download.effects';
import { DropOffLocationEffects } from './effects/drop-off-location.effects';
import { JobEffects } from './effects/job.effects';
import { JobUsersEffects } from "./effects/job-users.effects";
import { JobsEffects } from './effects/jobs.effects';
import { LoqateEffects } from './effects/loqate.effects';
import { OptionEffects } from './effects/option.effects';
import { OrganisationEffects } from './effects/organisation.effects';
import { OrganisationRoleEffects } from './effects/organisation-role.effects';
import { OrganisationSuiteEffects } from './effects/organisation-suite.effects';
import { OrganisationUsersEffects } from './effects/organisation-users.effects';
import { OrganisationsEffect } from './effects/organisations.effect';
import { SampleEffects } from './effects/sample.effect';
import { TemplateEffects } from './effects/template.effects';
import { TemplateSampleEffect } from './effects/template-sample.effect';
import { UserEffects } from './effects/user.effects';
import { UsersEffects } from './effects/users.effects';
import { AlertState, reducer as alertReducer } from './reducers/alert.reducer';
import { AssetState,reducer as assetsReducer } from './reducers/asset.reducer';
import {
  CognitoState,
  reducer as cognitoReducer,
} from './reducers/cognito.reducer';
import { DownloadState, reducer as downloadReducer } from './reducers/download.reducer';
import { DropOffLocationState, reducer as dropOffLocationReducer } from './reducers/drop-off-location.reducer';
import { JobState, reducer as jobReducer } from './reducers/job.reducer';
import { JobUsersState,reducer as jobUsersReducer} from './reducers/job-users.reducer'
import { JobsState, reducer as jobsReducer } from './reducers/jobs.reducer';
import {
  LoqateState,
  reducer as loqateReducer,
} from './reducers/loqate.reducer';
import {
  OptionState,
  reducer as optionReducer,
} from './reducers/option.reducer';
import {
  OrganisationState,
  reducer as organisationReducer,
} from './reducers/organisation.reducer';
import { organsiationRoleReducer, OrgansiationRoleState } from './reducers/organisation-role.reducer';
import { OrganisationSuiteState, reducer as organisationSuiteReducer } from './reducers/organisation-suite.reducer';
import {
  OrganisationUsersState,
  reducer as organisationUsers,
} from './reducers/organisation-users.reducer';
import {
  OrganisationsState,
  reducer as organisationsReducer,
} from './reducers/organisations.reducer';
import {
  reducer as sampleReducer,
  SampleState,
} from './reducers/sample.reducer';
import { reducer as templateReducer, TemplateState } from './reducers/template.reducer';
import { reducer as templateSampleReducer, TemplateSampleState } from './reducers/template-sample.reducer';
import { reducer as userReducer, UserState } from './reducers/user.reducer';
import { reducer as usersReducer, UsersState } from './reducers/users.reducer';

export interface AppState {
  cognito: CognitoState;
  job: JobState;
  jobs: JobsState;
  jobUsers: JobUsersState;
  loqate: LoqateState;
  organisation: OrganisationState;
  organisationUsers: OrganisationUsersState;
  organisations: OrganisationsState;
  option: OptionState;
  sample: SampleState;
  user: UserState;
  users: UsersState;
  alerts: AlertState;
  assets: AssetState;
  downloads: DownloadState;
  templates: TemplateState;
  templateSamples: TemplateSampleState;
  dropOffLocations: DropOffLocationState;
  organisationSuites: OrganisationSuiteState;
  roles: OrgansiationRoleState,
}

// Root reducers
export const reducers = {
  cognito: cognitoReducer,
  job: jobReducer,
  jobs: jobsReducer,
  jobUsers: jobUsersReducer,
  loqate: loqateReducer,
  organisation: organisationReducer,
  organisationUsers: organisationUsers,
  organisations: organisationsReducer,
  option: optionReducer,
  sample: sampleReducer,
  user: userReducer,
  users: usersReducer,
  alerts: alertReducer,
  assets: assetsReducer,
  downloads: downloadReducer,
  templates: templateReducer,
  templateSamples: templateSampleReducer,
  dropOffLocations: dropOffLocationReducer,
  organisationSuites: organisationSuiteReducer,
  roles: organsiationRoleReducer,
};

// Root effects
export const effects = [
  CognitoEffects,
  JobEffects,
  JobUsersEffects,
  JobsEffects,
  LoqateEffects,
  OrganisationEffects,
  OrganisationUsersEffects,
  OrganisationsEffect,
  OptionEffects,
  SampleEffects,
  UserEffects,
  UsersEffects,
  AssetsEffects,
  DownloadEffects,
  TemplateEffects,
  TemplateSampleEffect,
  DropOffLocationEffects,
  OrganisationSuiteEffects,
  OrganisationRoleEffects,
];

// Meta reducer for clearing the store on sign out
export const clearState =
  (reducer: ActionReducer<AppState>): ActionReducer<AppState> =>
  (state: AppState | undefined, action: Action): AppState => {
    if (
      action.type === CognitoActions.signOutSuccess.type ||
      action.type === CognitoActions.signIn.type
    ) {
      state = undefined;
    }

    return reducer(state, action);
  };
  
export const metaReducers: MetaReducer<AppState>[] = [clearState];
